import { AsyncAction } from '@cbgms/base/redux/async-action'
import { ProductIDType } from '../enums'
import { IVehicleLinkageCriteria, POSTVehicleTyreSuggestionResponse } from '.'
import * as requests from './requests'

export const getVehicleTyreSuggestion = (
  id: string,
  idType: ProductIDType,
  orderAccountUUID: string,
  vehicleUUID: string,
  vehicleLinkageCriteria: IVehicleLinkageCriteria[]
) =>
  AsyncAction<POSTVehicleTyreSuggestionResponse>({
    type: ['GET_VEHICLE_TYRE_SUGGESTION', 'GET_VEHICLE_TYRE_SUGGESTION_SUCCESS', 'GET_VEHICLE_TYRE_SUGGESTION_FAILED'],
    payload: {
      api: 'gms',
      request: requests.getVehicleTyreSuggestion(id, idType, orderAccountUUID, vehicleUUID, vehicleLinkageCriteria)
    }
  })
